import React, { useState, useEffect } from 'react';
import { Card, Table, Button, message, Space, Tag, Popconfirm } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import supplyChainService, { Supplier } from '../../../services/supplyChainService';

const SupplierList: React.FC = () => {
    const navigate = useNavigate();
    const [suppliers, setSuppliers] = useState<Supplier[]>([]);
    const [loading, setLoading] = useState(false);

    const fetchSuppliers = async () => {
        setLoading(true);
        try {
            const res = await supplyChainService.getSuppliers({ page_size: 1000 });
            const data = res.data as any;
            setSuppliers(Array.isArray(data) ? data : data?.results || []);
        } catch (error) {
            message.error('加载供应商列表失败');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchSuppliers();
    }, []);

    const handleAdd = () => {
        navigate('/supply-chain/procurement/suppliers/new');
    };

    const handleEdit = (record: Supplier) => {
        navigate(`/supply-chain/procurement/suppliers/${record.id}`);
    };

    const handleDelete = async (id: number) => {
        try {
            await supplyChainService.deleteSupplier(id);
            message.success('供应商已删除');
            fetchSuppliers();
        } catch (error) {
            message.error('删除失败');
        }
    };

    const columns = [
        {
            title: '供应商名称',
            dataIndex: 'name',
            key: 'name',
            width: 200,
            fixed: 'left' as const,
        },
        {
            title: '代码',
            dataIndex: 'code',
            key: 'code',
            width: 100,
        },
        {
            title: '联系人',
            dataIndex: 'contact_name',
            key: 'contact_name',
            width: 100,
        },
        {
            title: '电话',
            dataIndex: 'phone',
            key: 'phone',
            width: 140,
        },
        {
            title: '结算方式',
            dataIndex: 'payment_terms',
            key: 'payment_terms',
            width: 120,
        },
        {
            title: '交期(天)',
            dataIndex: 'lead_time_days',
            key: 'lead_time_days',
            width: 80,
        },
        {
            title: '状态',
            dataIndex: 'status',
            key: 'status',
            width: 80,
            render: (status: string) => (
                <Tag color={status === 'active' ? 'green' : 'default'}>
                    {status === 'active' ? '启用' : '停用'}
                </Tag>
            ),
        },
        {
            title: '操作',
            key: 'actions',
            width: 200,
            fixed: 'right' as const,
            render: (_: any, record: Supplier) => (
                <Space>
                    <Button type="link" size="small" onClick={() => navigate(`/supply-chain/procurement/suppliers/${record.id}/view`)}>
                        查看详情
                    </Button>
                    <Button type="link" size="small" icon={<EditOutlined />} onClick={() => handleEdit(record)}>
                        编辑
                    </Button>
                    <Popconfirm title="确定删除该供应商?" onConfirm={() => handleDelete(record.id!)}>
                        <Button type="link" size="small" danger icon={<DeleteOutlined />}>
                            删除
                        </Button>
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    return (
        <Card
            title="供应商管理"
            extra={
                <Button type="primary" icon={<PlusOutlined />} onClick={handleAdd}>
                    新增供应商
                </Button>
            }
        >
            <Table
                dataSource={suppliers}
                columns={columns}
                rowKey="id"
                loading={loading}
                pagination={{ pageSize: 20 }}
                scroll={{ x: 1100 }}
            />
        </Card>
    );
};

export default SupplierList;
